import OptionsPanel from "./OptionsPanel"
import Color from "./Color"

export default class WindowColor extends OptionsPanel {

  constructor(props, context) {
    super(props, context)

    this.state.title = "Window Color" // TODO: This needs to be localized
    this.setting = "windowColor"
    this.listOptions = props.labels[this.setting]
    this.select()
  }

  static get contextTypes() {
    return super.contextTypes
  }

}
